export const encodeXmlEntities = (s: string) => {
  const div = document.createElement('div');
  div.textContent = s;
  // 替换所有&为&amp;,且不能替换&amp;,否则会导致&amp;amp;
  return s.replaceAll(/&(?!(amp)|(lt)|(gt)|(quot)|(#39);)/g, '&amp;');
};
